import React from 'react';
import { Typography, Stack, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

interface VideoCarouselHeaderProps {
  onCreateCarousel: () => void;
}

export function VideoCarouselHeader({ onCreateCarousel }: VideoCarouselHeaderProps) {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 3 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
        Anpassade videokaruseller
      </Typography>
      <Button variant="contained" startIcon={<AddIcon />} onClick={onCreateCarousel}>
        Skapa ny karusell
      </Button>
    </Stack>
  );
}
